import styled from "styled-components";

const keyFrame = `
@keyframes rotate {
    0% {
      opacity:0;
    }
    100% {
      opacity:1;
    }
  }
`;

export const ContainerModalAutoT = styled.div`
  width: 359px;
  height: 304px;
  background-color: var(--color-white);
  border-radius: 8px;
  .backgorund-containerModalAutoT {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    height: 100dvh;
    z-index: -1;
    background: hsla(0, 0%, 0%, 0.5);
  }
  display: ${({ $active }) => ($active ? "" : "none")};
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
`;

const bodyHeight = 304 - 66;
export const ModalTopAutoT = styled.div`
  height: 66px;
  width: 100%;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background: var(--color-secondary-gradient);
  display: flex;
  align-items: center;
  gap: 20px;
  padding-left: 20px;
  h1 {
    margin: 0;
    font-size: 18px;
    color: var(--color-white);
    ${keyFrame};
    animation: rotate 0.5s linear;
  }
`;

export const ModalBodyAutoT = styled.div`
  width: 100%;
  height: ${`${bodyHeight}px`};
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  button {
    width: 160px;
    height: 40px;
    border-radius: 9px;
    margin: 10px;
    background-color: #ff6600;
    color: var(--color-white);
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    font-size: 18px;
  }
  .container-btn {
    display: flex;
  }
  .desc {
    text-align: center;
    font-size: 18px;
    padding: 0 14px;
  }
  ${keyFrame};
  animation: rotate 0.5s linear;
`;
